import { render, staticRenderFns } from "./preference-link.vue?vue&type=template&id=b6abce94"
import script from "./preference-link.vue?vue&type=script&lang=js"
export * from "./preference-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports